export default __webpack_public_path__ + "df7205b11357269dc876637f80a35cd9.png";